unit UDadosUsuarioVO;

interface

type
  TDadosUsuarioVO = class
  private
    FId,
    FPerfil,
    FDataBase,
    FAliado : Integer;
    FNome,
    FPerfilAcesso : string;

  public
    property Id: Integer read FId write FId;
    property Perfil: Integer read FPerfil write FPerfil;
    property DataBase: Integer read FDataBase write FDataBase;
    property Aliado: Integer read FAliado write FAliado;
    property Nome: string read FNome write FNome;
    property PerfilAcesso: string read FPerfilAcesso write FPerfilAcesso;
  end;

implementation

{ TDadosUsuarioVO }

end.
